export default __webpack_public_path__ + "static/media/final.6bfded31.MOV";